/**
 * How it works steps. The facts ship open in the markup so the page reads with
 * JavaScript off; this collapses them and wires the two controls: the one under
 * the row (from 560px) opens every step, and each step's own (under 560px)
 * opens that step. A step shows its facts when the shared control is open or
 * its own is, as the static build does. Labels come from the markup.
 */
export default function initSteps() {
	document.querySelectorAll('[data-steps]').forEach((root) => {
		const strip = root.querySelector('.step-strip');
		const allBtn = root.querySelector('[data-step-toggle-all]');
		if (!strip || !allBtn) return;

		const cells = Array.from(root.querySelectorAll('[data-step]')).map((li) => ({
			btn: li.querySelector('[data-step-toggle]'),
			facts: li.querySelector('[data-step-facts]'),
			open: false,
		}));
		let all = false;

		const render = () => {
			strip.classList.toggle('step-strip-facts', all);
			allBtn.setAttribute('aria-expanded', String(all));
			cells.forEach((c) => {
				const expanded = all || c.open;
				if (c.facts) c.facts.hidden = !expanded;
				if (c.btn) c.btn.setAttribute('aria-expanded', String(expanded));
			});
		};

		allBtn.addEventListener('click', () => {
			all = !all;
			render();
		});
		cells.forEach((c) => {
			if (!c.btn) return;
			c.btn.addEventListener('click', () => {
				c.open = !c.open;
				render();
			});
			c.btn.hidden = false;
		});
		allBtn.parentElement.hidden = false;
		render();
	});
}
